










































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import { mapActions } from 'vuex';

export default Vue.extend({
  data: () => ({
    singleSelect: false,
    row: null,
    selected: [],
    headers: [
      // { text: 'id', value: 'id', sortable: false },
      { text: 'Nombre', value: 'shortName' },
      { text: 'Nombre', value: 'longName' },
    ],
    total: 0,
    gridData: [],
    loading: true,
    options: {},
  }),
  mounted() {
    this.clearAdmin();
    this.clearCondo();
//    this.loadData();
  /*console.warn('TOASTER: %o',this.$toast);
  this.$toast.info('Info toast');
  this.$toast.warning('warn toast');
  this.$toast.error('error toast');
  this.$toast.custom('custom toast');
  this.$toast.success('success toast');
  */
  },
  methods: {
    ...mapActions(['getAdminList', 'setAdmin', 'clearAdmin', 'clearCondo']),
    async loadData() {
      try {
        this.loading = true;
        console.debug('getAdminList options: %o', this.options);
        const result = await this.$store.dispatch('getAdminList', this.options);
        console.debug('getAdminList response: %o', result.content);
        this.gridData = result.content;
        this.total = result.totalElements;
      } catch (e) {
        console.error('getAdminList error: %o', e);
        this.$toast.error(e);
      }
      this.loading = false;
    },
    rowSelected(event) {
      console.debug('Current event: %o', event);
      this.row = event;
      this.setAdmin(event);
      this.$router.push({name: 'condominiosSelector', params: {admin: event}});
    },
    async pageEventHandler(page) {
      console.debug('pageEventHandler ');
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
  },
});
